import { DEFAULT_WH_APPT_CODE, DEFAULT_WH_HRT_CLUB_APPT_CODE } from 'constants/defaults';

import { ProgramCode } from 'models/programs.types';

// Override of the default Women's Health visit code per WH program.
// A future variant (e.g. wh-hrt-home) is a one-line addition here.
export const WH_PROGRAM_APPT_CODE: Partial<Record<ProgramCode, string>> = {
  [ProgramCode.WomenHealthHRTClub]: DEFAULT_WH_HRT_CLUB_APPT_CODE
};

// All "Women's Health visit" codes (standard + program variants),
// for membership checks ("is this any WH visit code?").
export const WH_APPT_CODES = [DEFAULT_WH_APPT_CODE, ...Object.values(WH_PROGRAM_APPT_CODE)];
